// eslint-disable-next-line import/prefer-default-export
export const UPDATE_STATE: 'onboarding/UPDATE_STATE' = 'onboarding/UPDATE_STATE';
